//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MemberList",
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      filterFormMember: {
        fullName: "",
      },
      accounts: [], // 账号（角色成员）
    };
  },
  props: {
    dialogMemberVisible: {
      type: Boolean,
      default: () => false,
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    close(type) {
      this.$emit("close", "dialogMemberVisible", type);
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:34
     * @param {*} formName 表单ref名称
     */
    handleResetFilterMember(formName) {
      this.$refs[formName].resetFields();
      this.getAccountList();
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAccountList();
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:09
     */
    handleFilterMember() {
      this.getAccountList();
    },
    /**
     * @descripttion: 获取账号列表
     * @Author: juanjuanhui
     * @Date: 2022-02-23 11:41:48
     */
    getAccountList() {
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize };
      this.filterFormMember.roleId = this.curRoleDetail.id;
      Object.assign(params, params, this.filterFormMember);
      this.$http.account
        .getManageAccount({ ...params, systemType: this.systemType })
        .then((res) => {
          let { recordTotal, content: accounts } = res.data;
          this.pagination.recordTotal = recordTotal;
          this.accounts = accounts;
        });
    },
    /**
     * @descripttion: 移除角色
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:30:14
     * @param {*} item 当前数据项
     */
    handleRemoveRole(value) {
      this.$emit("setData", { label: "curAccountDetail", value });
      this.close("dialogRemoveRoleVisible");
    },
  },
  created() {},
  mounted() {
    this.getAccountList();
  },
};
